export default "__VITE_ASSET__YfIT3Frt__"